<template>
  <transition-group name='fade'>
    <!-- 蒙版 -->
    <div  @click="defaultMask" class="mask" key="1" v-if="show" @touchmove.prevent></div>

    <div class="lampPop" v-show="show" key="2">
      <div class="lampPop-title">
        <span class="lampPop-title-name">设备操作</span>
        <el-button class="lampPop-title-close" icon="el-icon-close" type="text" @click="close"></el-button>
      </div>

      <div class="lampPop-sign">
        <div class="lampPop-sign-name">
          <span class="lampPop-sign-nameOpt">设备ID</span>
        </div>
        <div class="lampPop-sign-value">
          <span class="lampPop-sign-valueOpt">{{deviceAddr}}</span>
        </div>
      </div>
      <div class="lamp-line"></div>

      <div class="lampPop-middle">
        <div class="lampPop-middle-title">开灯设置</div>
        <div class="lampPop-middle-content">
          <div class="lampPop-middle-contentOpt">
            <span style="cursor: pointer" @click="openLamp">开灯</span>
          </div>
        </div>
      </div>
      <div class="lamp-line"></div>

      <div class="lampPop-middle">
        <div class="lampPop-middle-title">关灯设置</div>
        <div class="lampPop-middle-content">
          <div class="lampPop-middle-contentOpt">
            <span style="cursor: pointer" @click="closeLamp">关灯</span>
          </div>
        </div>
      </div>
    </div>
  </transition-group>
</template>

<script>
  import {lampOrderOperate} from "../../until/api/SporePest";

  export default {
    name: 'lampOperation',
    data() {
      return {
        deviceAddr: '',
        show: false,
      }
    },
    created() {
    },
    mounted() {
    },

    methods: {
      /**
       * 杀虫灯开灯
       */
      openLamp() {
        this.$confirm('请确定是否要开灯', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => { //确认开灯
          let param = {"DeviceID": this.deviceAddr, "Order": "L,1"};
          console.log("开灯状态", param);
          lampOrderOperate(param).then(response => {
            if(response.data.code == 200) { //开灯成功
              this.$message({
                showClose: true,
                type: 'success',
                message: '杀虫灯打开灯光成功'
              })
            } else { //开灯失败
              this.$message({
                showClose: true,
                type: 'warning',
                message: '杀虫灯打开灯光失败'
              })
            }
          }).catch(error => {
            console.log("error", error)
          })
        }).catch(() => { //取消开灯
          this.$message({
            showClose: true,
            type: 'warning',
            message: '杀虫灯开灯已取消'
          })
        })
      },

      /**
       * 杀虫灯关灯
       */
      closeLamp() {
        this.$confirm('请确定是否要关灯', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => { //确认关灯
          let param = {"DeviceID": this.deviceAddr, "Order": "L,0"};
          console.log("关灯状态", param);
          lampOrderOperate(param).then(response => {
            if(response.data.code == 200) { //关灯成功
              this.$message({
                showClose: true,
                type: 'success',
                message: '杀虫灯关闭灯光成功'
              })
            } else {
              this.$message({ //关灯失败
                showClose: true,
                type: 'warning',
                message: '杀虫灯关闭灯光失败'
              })
            }
          }).catch(error => {
            console.log("error", error)
          })
        }).catch(() => { //取消关灯
          this.$message({
            showClose: true,
            type: 'warning',
            message: '杀虫灯关灯已取消'
          })
        })
      },

      close() {
        this.show = false;
      },
      defaultMask() {
        this.show = false;
      }
    }
  }
</script>

<style lang="less" scoped>
  // 渐变过渡
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.35s;
  }

  // 全局弹窗
  .mask {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
  }

  .lampPop {
    height: 25%;
    width: 20%;
    background: #2B5DA0;
    border-radius: 8px;
    position: fixed;
    top: 30%;
    left: 50%;
    margin-left: -10%;
    z-index: 20;

    .lampPop-title {
      width: 100%;
      display: table;
      color: #ffffff;
      height: 19%;
      font-size: 26px;
      font-family: SimSun;

      .lampPop-title-name {
        display: table-cell;
        vertical-align: middle;
        padding-left: 40%;
      }

      .lampPop-title-close {
        float: right;
        padding: 3px 3px;
        color: cyan
      }
    }

    .lampPop-sign {
      width: 100%;
      height: 19%;
      display: flex;
      flex-direction: row;
      font-size: 24px;
      color: #ffffff;
      font-family: SimSun;

      .lampPop-sign-name {
        width: 40%;
        height: 100%;
        display: table;

        .lampPop-sign-nameOpt {
          display: table-cell;
          vertical-align: middle;
          text-align: center
        }
      }

      .lampPop-sign-value {
        width: 60%;
        height: 100%;
        display: table;

        .lampPop-sign-valueOpt {
          display: table-cell;
          vertical-align: middle;
          text-align: center
        }
      }
    }

    .lampPop-middle {
      width: 100%;
      height: 28%;
      font-family: SimSun;

      .lampPop-middle-title {
        width: 100%;
        height: 40%;
        color: #ffffff;
        font-size: 16px;
        padding-left: 1.5%;
        padding-top: 1.5%;
      }

      .lampPop-middle-content {
        width: 100%;
        height: 60%;
        display: table;

        .lampPop-middle-contentOpt {
          display: table-cell;
          vertical-align: middle;
          text-align: center;
          color: #5BDAFB;
          font-size: 26px;
        }
      }
    }

    .lamp-line {
      width: 96%;
      height: 0.5%;
      background-color: cyan;
      margin-left: 2%;
      margin-top: 1%
    }

    .el-card {
      background-color:transparent;
      border: none;
    }

    /deep/ .el-input__inner {
      background-color: transparent;
      border: 1px solid #4CD7E3;
      color: #ffffff;
      width: 60%;
    }

    /deep/ .el-input__icon{
      font-size:24px;
      margin-top: 10px;
    }
  }

</style>




// WEBPACK FOOTER //
// src/components/popup/lampOperation.vue